import React from "react";

import { useAuth } from "../../AuthContext/AuthContext";
import { Puff } from "react-loader-spinner";


const Loader: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screnn ">
      <Puff
        visible={true}
        height="60"
        width="60"
        color="#75A7AD"
        ariaLabel="puff-loading"
      />
    </div>
  );
};

const MyProfile: React.FC = () => {

  const { user,  } = useAuth();

  return (
    <div>
      {user ? (
        <div>
          <div
            className="relative overflow-x-auto"
            style={{ backgroundColor: "transparent" }}>
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase dark:text-gray-400">
                <tr className="bg-[#75A7AD] text-white text-[16px] h-[65px] w-full">
                  <th scope="col" className="px-6 py-3">
                    Account Details
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="">
                  <td className="px-6 py-4">{user?.firstName}</td>
                  <td className="px-6 py-4">{user?.lastName}</td>
                  <td className="px-6 py-4">{user?.email}</td>
                  <td className="px-6 py-4">{user?.phone_number}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div>
          <Loader />
        </div>
      )}
    </div>
  );
};

export default MyProfile;
